module.exports = __webpack_public_path__ + "static/media/homepage-introdution-vector.01a7cc72.png";